import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  position: relative;

  width: 100%;
  /* width: 100%;
  height: 300px;
  max-width: 500px; */
`;

export const ContainerIconPlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  z-index: 2;

  width: 100%;
  max-width: 700px;
  height: 100%;

  .centralizer {
    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      height: max-content;
      width: max-content;

      .icon-play {
        width: 65px;
        height: 65px;
      }

      transition: all ease-in-out 0.4s;

      &:hover {
        transform: scale(1.1);
        transition: all ease-in-out 0.4s;
      }
    }
  }
`;

export const ImageSection = styled.div`
  width: 100%;
  z-index: 1;

  img {
    border-radius: 10px 10px 0 0;
    width: inherit;
  }
`;
